/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  DataImportRetrieveModel,
  Forbidden,
  NotFound,
  Unauthorized,
  WorkItemModel,
} from '../models';

export interface DataImportAddImportDataBySiteIdRequest {
    siteId: string;
    dataImportRetrieveModel: DataImportRetrieveModel;
}

export interface DataImportGetImportBySiteIdRequest {
    siteId: string;
    configId?: string;
    action?: string;
}

/**
 * 
 */
export class DataImportApi extends runtime.BaseAPI {

    /**
     * This method allows to reimport data directly by the given siteId and configId
     * Add an import item to the import stack
     */
    async dataImportAddImportDataBySiteIdRaw(requestParameters: DataImportAddImportDataBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
            throw new runtime.RequiredError('siteId','Required parameter requestParameters.siteId was null or undefined when calling dataImportAddImportDataBySiteId.');
        }

        if (requestParameters.dataImportRetrieveModel === null || requestParameters.dataImportRetrieveModel === undefined) {
            throw new runtime.RequiredError('dataImportRetrieveModel','Required parameter requestParameters.dataImportRetrieveModel was null or undefined when calling dataImportAddImportDataBySiteId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/data-import/site/{siteId}`.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters.siteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.dataImportRetrieveModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This method allows to reimport data directly by the given siteId and configId
     * Add an import item to the import stack
     */
    async dataImportAddImportDataBySiteId(requestParameters: DataImportAddImportDataBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dataImportAddImportDataBySiteIdRaw(requestParameters, initOverrides);
    }

    /**
     * Getting list of all imported information for the given siteId. Can be filtered by action and or configId
     * Get list of ImportWorkItems
     */
    async dataImportGetImportBySiteIdRaw(requestParameters: DataImportGetImportBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkItemModel>>> {
        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
            throw new runtime.RequiredError('siteId','Required parameter requestParameters.siteId was null or undefined when calling dataImportGetImportBySiteId.');
        }

        const queryParameters: any = {};

        if (requestParameters.configId !== undefined) {
            queryParameters['configId'] = requestParameters.configId;
        }

        if (requestParameters.action !== undefined) {
            queryParameters['action'] = requestParameters.action;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/data-import/site/{siteId}`.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters.siteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Getting list of all imported information for the given siteId. Can be filtered by action and or configId
     * Get list of ImportWorkItems
     */
    async dataImportGetImportBySiteId(requestParameters: DataImportGetImportBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkItemModel>> {
        const response = await this.dataImportGetImportBySiteIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
